module.exports = __webpack_public_path__ + "img/course_007.2327826.png";